var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFitContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 5.90244,
    height: 5.90244,
    id: "canvas_background",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "canvasGrid",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "svg_1",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    strokeWidth: 0,
    fill: "url(#gridpattern)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeOpacity: "null",
    fillOpacity: "null",
    x1: 1.18751,
    y1: 2.18557,
    x2: 10.33388,
    y2: 2.18557,
    id: "svg_16",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeOpacity: "null",
    fillOpacity: "null",
    x1: 13.43751,
    y1: 2.18557,
    x2: 22.58388,
    y2: 2.18557,
    id: "svg_18",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeOpacity: "null",
    fillOpacity: "null",
    x1: 1.31251,
    y1: 21.31053,
    x2: 10.45888,
    y2: 21.31053,
    id: "svg_19",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeOpacity: "null",
    fillOpacity: "null",
    x1: 13.4375,
    y1: 21.31053,
    x2: 22.58387,
    y2: 21.31053,
    id: "svg_20",
    strokeLinejoin: "null",
    strokeLinecap: "null"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeOpacity: "null",
    fillOpacity: "null",
    x1: 17.0625,
    y1: 5.81055,
    x2: 26.20887,
    y2: 5.81055,
    id: "svg_21",
    strokeLinejoin: "null",
    strokeLinecap: "null",
    transform: "rotate(90 21.635686874389652,5.810550212860109) "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeOpacity: "null",
    fillOpacity: "null",
    x1: 17.0625,
    y1: 17.68554,
    x2: 26.20887,
    y2: 17.68554,
    id: "svg_22",
    strokeLinejoin: "null",
    strokeLinecap: "null",
    transform: "rotate(90 21.63568687438965,17.685539245605472) "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeOpacity: "null",
    fillOpacity: "null",
    x1: -2.43746,
    y1: 17.68554,
    x2: 6.70891,
    y2: 17.68554,
    id: "svg_23",
    strokeLinejoin: "null",
    strokeLinecap: "null",
    transform: "rotate(90 2.1357207298278778,17.685539245605472) "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeOpacity: "null",
    fillOpacity: "null",
    x1: -2.43746,
    y1: 5.81055,
    x2: 6.70891,
    y2: 5.81055,
    id: "svg_24",
    strokeLinejoin: "null",
    strokeLinecap: "null",
    transform: "rotate(90 2.1357207298278804,5.810550212860108) "
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 6.06251,
    y: 5.81055,
    width: 8.99999,
    height: 6.74999,
    id: "svg_25",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    strokeOpacity: "null",
    fillOpacity: "null",
    x: 8.81251,
    y: 10.18555,
    width: 8.99999,
    height: 6.74999,
    id: "svg_26",
    stroke: "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitContent);
export default __webpack_public_path__ + "static/media/fitContent.6793896b23bbe410eabba3addb00cb2c.svg";
export { ForwardRef as ReactComponent };